import { render, staticRenderFns } from "./register-addr.vue?vue&type=template&id=475e10f5&scoped=true&"
import script from "./register-addr.vue?vue&type=script&lang=js&"
export * from "./register-addr.vue?vue&type=script&lang=js&"
import style0 from "./register-addr.vue?vue&type=style&index=0&id=475e10f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475e10f5",
  null
  
)

export default component.exports